import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type AuthState = {
  token: string | null;
  name: string | null;
};

const initialState: AuthState = {
  token: null,
  name: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (
      state,
      { payload: { token, name } }: PayloadAction<{ token: string; name: string }>
    ) => {
      state.token = token;
      state.name = name;
    },
  },
});

export const { setCredentials } = authSlice.actions;

export const { reducer: authReducer } = authSlice;
